import React from "react";

const Java_Exercises = () => {
  return (
    <div>
      <h1>Java Exercises</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Exercises in Java.</p>
    </div>
  );
};

export default Java_Exercises;
